import './Profile.css';
import React, { useState } from "react";
import UserProfile from './components/user/UserProfile.js'
import CreateUserProfile from './components/user/CreateUserProfile.js'
import EditPillar from './goals/pillars/EditPillar.js'
import AddPillar from './components/user/AddPillar.js'
import AddProject from './components/user/AddProject.js'
import EditProject from './goals/pillars/EditProject.js'
import EditRoutine from './components/user/EditRoutine.js';

const Profile = (props) => {
    const [activeProject, setActiveProject] = useState(null)
    const [activePillar, setActivePillar] = useState(null)
    const [showAddPillar, setShowAddPillar] = useState(false)
    const [showAddProject, setShowAddProject] = useState(false)
    const [showEditMorningRoutine, setShowEditMorningRoutine] = useState(false)
    const [showEditEveningRoutine, setShowEditEveningRoutine] = useState(false)
    let showSetUserData = (props.userProfile.name === null)

    function changeActivePillar(pillar) {
        setActivePillar(pillar)
        setActiveProject(null)
    }

    function changeActiveProject(project) {
        setActiveProject(project)
        setActivePillar(null)
    }

    function hideAddProject() {
        setShowAddProject(false)
    }

    function closeMorningRoutine() {
        setShowEditMorningRoutine(false)
    }

    function closeEveningRoutine() {
        setShowEditEveningRoutine(false)
    }

    return (
        <div className="profile">
            <p className="profileHeaderText"> USER DETAILS:</p>
            {showSetUserData &&
                <div>
                    <CreateUserProfile />
                </div>
            }
            {!showSetUserData &&
                <div>
                    <p className="profileText"> user projects: </p>
                    <div className="pillarButtonRow">
                        <p onClick={() => setShowAddProject(!showAddProject)} className="addProfileInfoButton"> {showAddProject ? "hide add project" : "add project"} </p>
                    </div>
                    {showAddProject &&
                        <AddProject pushChanges={true} userProfile={props.userProfile} setUserProfile={props.setUserProfile} hideAddProject={hideAddProject} />
                    }
                    {activeProject !== null &&
                        <EditProject userProfile={props.userProfile} setUserProfile={props.setUserProfile} activeProject={activeProject} setActiveProject={setActiveProject} />
                    }
                    <div className="profileInfoRow projectUserProfileRow">
                        {props.userProfile.projects.map((project, index) => (
                            <div key={index} onClick={() => changeActiveProject(index)} className="profileInfoDiv">
                                <p className={"profileInfoText"}> {project.shortName} </p>
                            </div>
                        ))}
                    </div>

                    <p className="profileText"> user pillars: </p>
                    <div className="pillarButtonRow">
                        <p onClick={() => setShowAddPillar(!showAddPillar)} className="addProfileInfoButton"> {showAddPillar ? "hide add pillar" : "add pillar"} </p>
                    </div>
                    {showAddPillar &&
                        <AddPillar pushChanges={true} userProfile={props.userProfile} setUserProfile={props.setUserProfile} />
                    }
                    {activePillar !== null &&
                        <EditPillar userProfile={props.userProfile} setUserProfile={props.setUserProfile} activePillar={activePillar} setActivePillar={setActivePillar} />
                    }
                    <div className="profileInfoRow">
                        {props.userProfile.pillars.map((pillar, index) => (
                            <div key={index} onClick={() => changeActivePillar(pillar)} className="profileInfoDiv">
                                <p className={"profileInfoText"}>{pillar.title}</p>
                            </div>
                        ))}
                    </div>

                    <p className="profileText"> user schedule: </p>
                    <div className="pillarButtonRow">
                        <p onClick={() => props.setActivePage("schedule")} className="addProfileInfoButton"> go to edit schedule view</p>
                    </div>
                    <p className="profileText"> user morning routine: </p>
                    <div className="pillarButtonRow">
                        <p onClick={() => setShowEditMorningRoutine(!showEditMorningRoutine)} className="addProfileInfoButton"> {showEditMorningRoutine ? "hide edit routine" : "edit morning routine"} </p>
                    </div>
                    {!showEditMorningRoutine &&
                        <div className="routineGroupUserProfile">
                            {props.userProfile.morningRoutineSteps.map((step, index) => (
                                <div>
                                    <p className="routineStepText"> step #{index + 1}: {step} </p>
                                </div>
                            ))}
                        </div>
                    }
                    {showEditMorningRoutine &&
                        <EditRoutine type="morning" closeFunction={closeMorningRoutine} userProfile={props.userProfile} setUserProfile={props.setUserProfile} />
                    }


                    <p className="profileText"> user evening routine: </p>
                    <div className="pillarButtonRow">
                        <p onClick={() => setShowEditEveningRoutine(!showEditEveningRoutine)} className="addProfileInfoButton"> {showEditEveningRoutine ? "hide edit routine" : "edit evening routine"} </p>
                    </div>
                    {!showEditEveningRoutine &&
                    <div className="routineGroupUserProfile">
                        {props.userProfile.eveningRoutineSteps.map((step, index) => (
                            <div>
                                <p className="routineStepText"> step #{index + 1}: {step} </p>
                            </div>
                        ))}
                    </div>
                    }
                    {showEditEveningRoutine &&
                        <EditRoutine type="evening" closeFunction={closeEveningRoutine} userProfile={props.userProfile} setUserProfile={props.setUserProfile} />
                    }
                </div>
            }
            <UserProfile userProfile={props.userProfile} />
        </div>
    )
}

export default Profile;